import { Card, Typography, Modal } from "antd";
import {
  PlusCircleOutlined,
  FileAddOutlined,
  ThunderboltOutlined,
  CheckCircleOutlined,
  MessageOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { useEffect, type CSSProperties } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { openMenuTab } from "../../../utils/menu/menutabs";
import "../../../style/bookingTabs.css";

const { Title } = Typography;

const page: CSSProperties = {
  minHeight: "100%",
  background: "#d6d2d24b",
  position: "relative",
};

const contentCard: CSSProperties = {
  borderRadius: 24,
  border: "none",
  boxShadow: "0 25px 60px rgba(0,0,0,0.08)",
  backgroundColor: "#ffffff52",
};

const Booking: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname.replace("/booking/", "");

  const tabs = [
    {
      key: "add",
      label: "Add Booking",
      color: "#00d2a8",
      icon: <PlusCircleOutlined />,
      count: 0,
    },
    {
      key: "new",
      label: "New Bookings",
      color: "#ff9f1c",
      icon: <FileAddOutlined />,
      count: 14,
    },
    {
      key: "live",
      label: "Live Trips",
      color: "#3a86ff",
      icon: <ThunderboltOutlined />,
      count: 6,
    },
    {
      key: "completed",
      label: "Completed",
      color: "#2ecc71",
      icon: <CheckCircleOutlined />,
      count: 28,
    },
    {
      key: "enquiry",
      label: "Enquiries",
      color: "#9b59b6",
      icon: <MessageOutlined />,
      count: 9,
    },
    {
      key: "cancel",
      label: "Cancelled",
      color: "#ff4d6d",
      icon: <MinusCircleOutlined />,
      count: 3,
    },
  ];

  useEffect(() => {
    if (
      location.pathname === "/booking" ||
      location.pathname === "/booking/"
    ) {
      navigate("/booking/live", { replace: true });
      return;
    }

    if (!validTab) {
      Modal.error({
        title: "Invalid Page",
        content: `"${currentPath}" is not a valid booking page.`,
        okText: "Go to Bookings",
        onOk: () => navigate("/booking/live", { replace: true }),
      });
      navigate("/booking/live", { replace: true });
    }
  }, [location.pathname]);

  const validTab = tabs.some((t) => currentPath.includes(t.key));
  const currentTab = validTab ? currentPath.split("/")[0] : "";

  return (
    <div style={page}>

      <div className="booking-tabs">
        {tabs.map((tab) => {
          const active = tab.key === currentTab;

          return (
            <div
              key={tab.key}
              className="booking-tab"
              onClick={() => {
                if (!active) openMenuTab(`/booking/${tab.key}`);
              }}
              style={{
                cursor: active ? "default" : "pointer",
                borderBottom: active
                  ? `3px solid ${tab.color}`
                  : "3px solid transparent",
              }}
            >
              {/* <Badge count={tab.count} offset={[5, -5]}> */}
              <div
                className="booking-tab-icon"
                style={{
                  background: active ? tab.color : "#fff",
                  color: active ? "#fff" : tab.color,
                }}
              >
                {tab.icon}
              </div>
              {/* </Badge> */}

              <span
                className="booking-tab-label"
                style={{ fontWeight: active ? 700 : 500 }}
              >
                {tab.label}
              </span>
            </div>
          );
        })}
      </div>

      <Card style={contentCard}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -16 }}
            transition={{ duration: 0.25, ease: "easeInOut" }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </Card>
    </div>
  );
};

export default Booking;
